import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { history } from '../../_helpers';
import { domainActions } from '../../_actions';

import CellLogo from '../../_assets/cell_logo_white.png';

class NavbarComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: JSON.parse(sessionStorage.getItem('cellit_userdata')).username.substr(0, 2),
      sidebar: '',
      domains: [],
      selected: '',
      sidebarOpen: false
    }

    this.openSidebar = React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.handleSidebarOpening = this.handleSidebarOpening.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    let self = this;

    dispatch(domainActions.getDomainsByToken())
      .then(res => {
        if ( res.type === 'VERIFY_DOMAIN_FAILURE' ) return history.push('/domains');

        if ( history.location.pathname !== '/domains' ) {
          if ( res.data.data.length === 0 ) return history.push('/domains');
        }

        if ( !sessionStorage.getItem('selected_domain') ) {
          sessionStorage.setItem('selected_domain', JSON.stringify({domain: res.data.data[0].name, uuid: res.data.data[0].uuid}));
        }
        
        self.setState({selected: JSON.parse(sessionStorage.getItem('selected_domain')).domain});
        self.setState({domains: res.data.data});
      });
  }

  handleChange(e) {
    let name = e.target.selectedOptions[0].getAttribute('name');
    let value = e.target.value;

    sessionStorage.setItem('selected_domain', JSON.stringify({domain: name, uuid: value}));
    history.push(`${history.location.pathname}?domain=${value}`);
  }

  handleSidebarOpening() {
    let sidebar = '';

    if ( this.state.sidebar === '' ) {
      sidebar = document.querySelector('.sidebar');
    } else {
      sidebar = this.state.sidebar;
    }

    if ( this.state.sidebarOpen === true ) {
      sidebar.classList.remove('active');
      this.setState({sidebarOpen: false});
    } else {
      sidebar.classList.add('active');
      this.setState({sidebarOpen: true});
    }
  }

  render() {
    return (
      <nav className="navbar navbar-component">
        <button className="open-sidebar" ref={this.openSidebar} onClick={this.handleSidebarOpening}>
          <i className="linearicons-menu"></i>
        </button>

        <div className="container-fluid">
          <div className="row">
            <div className="col">
              <Link to="/" className="logo">
                <img src={CellLogo} alt="Cell logo with blue as predominant color"/>
              </Link>
            </div>

            <div className="col remove-domain-selector">
              <div className="domain-selector">
                <div className="select-group">
                  <select name="domain_selector" id="domain_selector" className="form-control" defaultValue="0" onChange={this.handleChange} required>
                    {
                      this.state.domains.length !== 0 ?
                        this.state.domains.map((domain, index) => {
                          return <option key={index} name={domain.name} value={domain.uuid} defaultValue={this.state.selected === domain.name ? true : false}>{domain.name}</option>
                        })
                      : false
                    }
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    )
  }
}

function mapStateToProps(state) {
  const { domains } = state.listDomainsReducer;
  return domains;
}

const ConnectedNavbarComponent = connect(mapStateToProps)(NavbarComponent);
export { ConnectedNavbarComponent as Navbar };